import React from 'react';
import '../styles/GameOver.css';

function GameOver({ gameStatus, word, onPlayAgain }) {
  return (
    <div className="game-over-container">
      <div className="game-over-content">
        <h2 className={`game-result ${gameStatus}`}>
          {gameStatus === 'won' ? 'You Won!' : 'Game Over'}
        </h2>
        
        <div className="word-reveal">
          The word was: <span className="revealed-word">{word}</span>
        </div>
        
        <button 
          className="play-again-btn"
          onClick={onPlayAgain}
        >
          Play Again
        </button>
      </div>
    </div>
  );
}

export default GameOver; 